/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsVariantOptions = {
    init: function($section) {
      $('.variant-option-colors').click(function(){
        var index = $(this).data('index');            
        $('.variant-option-colors').removeClass('is-active');
        $(this).addClass('is-active');            
        $('.option-thumbs-item').removeClass('is-visible');
        $('.option-thumbs-'+index).addClass('is-visible');    
    })

    const $sliderElement = $section.find('[data-mobile-slider]');

      let slider = $sliderElement.flickity({
        wrapAround: true,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: 'left',
      });
      
      $section.on('click touchstart', '[data-dot]', function (e) {        
        $('.variant-dot-mobile > div').removeClass('is-active');
        $(this).addClass('is-active');
        let index = $(this).data('index')
        slider.flickity('select', index);
      });
      setTimeout(function () {
        slider.flickity('resize');
      }, 500);

      slider.on('select.flickity', function(event, index) {        
        let CurrentSlide = index + 1;        
        $('.variant-dot-mobile > div:nth-child('+CurrentSlide+')').addClass('is-active').siblings().removeClass('is-active');   
        $('.variant-options-section').flickity('select', index);
      });
      
    },
    unload: function($section) {
      const $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }
  
  /******/ })()
  ;